import { container } from "../../containers";
import { isFalse, isSkland } from "../../helper";
// type Orientation = "landscape" | "portrait" | "auto";
// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var UI = /** @class */ (function () {
    function UI(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(UI.prototype, "header", {
        /**
         * ui_header 参数，在森空岛APP下也会读 header 参数，优先级 header > ui_header
         */
        get: function () {
            var ui_header = this.adapter.getStore().ui_header;
            return ui_header;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "nav", {
        /**
         * ui_nav 参数
         */
        get: function () {
            var ui_nav = this.adapter.getStore().ui_nav;
            return ui_nav;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "footer", {
        /**
         * ui_footer 参数
         */
        get: function () {
            var ui_footer = this.adapter.getStore().ui_footer;
            return ui_footer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "returnButton", {
        /**
         * ui_return 参数
         */
        get: function () {
            var _a = this.adapter.getStore(), ui_return = _a.ui_return, header = _a.header;
            if (ui_return !== undefined) {
                return ui_return;
            }
            if (isSkland && isFalse(header)) {
                return true;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 当 ui_return 为 true 时，会尝试找到当前 container 下的 onReturn 事件，例如在森空岛内会使用 bridge.pop 退出 webview
     */
    Object.defineProperty(UI.prototype, "onReturn", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            if (this.returnButton !== true) {
                console.warn("should not use onReturn when returnButton is false");
                return;
            }
            (_a = container.onReturn) === null || _a === void 0 ? void 0 : _a.call(container);
        }
    });
    Object.defineProperty(UI.prototype, "share", {
        /**
         * ui_share 参数
         */
        get: function () {
            var ui_share = this.adapter.getStore().ui_share;
            return ui_share;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "theme", {
        /**
         * ui_theme 参数，可能为 normal, light, dark
         */
        get: function () {
            var ui_theme = this.adapter.getStore().ui_theme;
            if (typeof ui_theme === "string" &&
                ["normal", "light", "dark"].includes(ui_theme) === false) {
                return undefined;
            }
            return ui_theme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UI.prototype, "style", {
        /**
         * ui_style 参数
         */
        get: function () {
            var ui_style = this.adapter.getStore().ui_style;
            return ui_style;
        },
        enumerable: false,
        configurable: true
    });
    return UI;
}());
export { UI };
